
import React, { useState, useEffect } from 'react';

import { SmartHash } from "@models";

import DandDAPI from "@dndUtilities/system_api";

import FSIndex from "@dndComponents/FSIndex";
import LoadingBox from "@components/input/LoadingBox";

const api = DandDAPI.getInstance();

export default function MagicItemKeywordIndex() {
  const [fetched, setFetched] = useState(false);
  const [loading, setLoading] = useState(false);

  useEffect(() => {
    if (!fetched) {
      load();
    }
  });
    
  const load = () => {
    setLoading(true);
    const onComplete = (res: SmartHash) => {
      if (res.magic_item_keyword) {
        setLoading(false);
      }
    }

    const onProgress = () => {};
    // Loading these is to make it so the details show properly
    api.getSetOfObjectsWithCallbacks({ 
      data_types: ["item","magic_item_keyword"],
      onComplete, onProgress 
    });
    setFetched(true);
  }
  
  if (!fetched || loading) {
    return (<LoadingBox />);
  } else {
    return (
      <FSIndex
        data_type="magic_item_keyword"
        // save_all
        // extra_filter={(obj: ModelBase | PlayerObject) => {
        //   return obj instanceof MagicItemKeyword && (obj.proficiency_req_options.includes("None") || obj.proficiency_req_options.includes("True None"));
        //   // return obj instanceof MagicItemKeyword && obj.feature_bases.filter(o => o.features.filter(o2 => o2.floating_feature instanceof Modifier && o2.floating_feature.modifies === "Attack" && o2.floating_feature.modifies_details.length === 0).length > 0).length > 0;
        // }}
        quick_fields={["item_type","effect_type","damage_type","rarities"]}
      />
    );
  }
}
